<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },

  components: {

  },

  methods: {

  }
}
</script>

<style>
 a {
   text-decoration: none;
   color: #4399e8;
 }

 .spanAsALabel {
   cursor:pointer;
   color: #4399e8;
 }

 .clearfix:after {
   visibility: hidden;
   display: block;
   font-size: 0;
   content: " ";
   clear: both;
   height: 0;
 }


 .recreation-wrapper {
   /*border: 1px solid red;*/
   /*height: 160px;*/
   margin-bottom: 16px;
 }

 .recreation-item {
   position: relative;
   /*border: 1px solid green;*/
   margin-top: 6px;
 }

 .storefront-item {
   position: relative;
   /*border: 1px solid green;*/
   margin-top: 6px;
   height: 250px;
 }

 .text-part {
   /*float: left;*/
   /*border: 1px solid blue;*/
   width: 550px;
 }

 .image-part {
   /*float: left;*/
   position: absolute;
   left: 560px;
   top: 0px;
   width: 240px;
   height: 180px;
 }

 .text-item {
   line-height: 36px;
   color: #333;
 }

 .text-sub-item {
   /*border: 1px solid black;*/
   width: 30%;
 }

 span {
   display: inline-block;
 }

 .text-item-label {

   /*width: 76px;*/
   text-align: right;
 }

 .query-item {
   float: left;
 }


 /*重写vue-directive-image-previewer/dist/assets/style.css 的类，将z-index:999，以便预览的图像置在顶层*/
 .vue-directive-image-previewer-body {
   width:100%;
   height:100%;
   z-index:999
 }
 .vue-directive-image-previewer-body img {
   position:absolute;
   z-index:999
 }
</style>



// WEBPACK FOOTER //
// src/App.vue